import { VF_DATE_PICKER } from 'AppSrc/core/components/forms/form-base-components/v-f-date-picker';
import {
  INLINE_ERRORS,
  // SILENT_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';

const fieldId = 'actual_start_date';

const validator = (params) => {
  const {
    values,
    field,
    // formData,
  } = params;
  const {
    optional,
  } = field;

  const value = values[fieldId];


  // const { minDate, maxDate } = field.componentData.vFParams;
  // const dateIsBeforeMin = commonValidation.date.isBeforeMinDate(value, minDate);
  // const dateIsAfterMax = commonValidation.date.isAfterMaxDate(value, maxDate);


  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(value, VF_DATE_PICKER);

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please enter Actual start and end date/time.' : null);
  // errors[INLINE_ERRORS].push((noValue && !optional) ? <FieldWarningError /> : null);
  // errors[INLINE_ERRORS].push(dateIsBeforeMin ? 'The start date can not be before the CRQ scheduled start date' : null);
  // errors[INLINE_ERRORS].push(dateIsAfterMax ? 'The start date can not be after the CRQ scheduled end date' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

// This overwritten by the form :)
const initialValues = null;

const vFParams = {
  fieldTitle: 'Actual start date/time',
  displayType: 'small',
};

const actualStartDate = {
  id: fieldId,
  validator,
  vFParams,
  initialValues,
  fieldType: VF_DATE_PICKER,
};

export { actualStartDate };
